import type { Staff } from "./store";
import { isCskhDesk, isReceptionDesk } from "@/lib/auth/page-access";
import { qcKindOf } from "@/lib/auth/role-labels";
import { ROLE } from "@/lib/auth/roles";

/**
 * Trang mở đầu sau khi đăng nhập / mở app. Nhân sự quầy lễ tân vào thẳng Lịch
 * chụp hôm nay — màn họ nhìn cả ngày (CEO chốt 27/09/2026, câu 3a); nhân sự
 * phòng CSKH vào thẳng Chat khách — việc đầu tiên trong ca là trả lời khách
 * đang chờ (CEO chốt 6a, 09/10/2026); QC vào thẳng màn làm việc chính của
 * mình (QĐ 0521): QC sửa hình (CEO 1b), QC chụp ảnh + QC trang điểm (vòng 3 ·
 * 3a) vào Chấm bài, QC cơ sở vào Kiểm cơ sở, QC CSKH vào Soi hành trình khách
 * (vòng 4, CEO 1a · 2a); mọi vai
 * khác vẫn vào Tổng quan. Chỉ đổi điểm HẠ CÁNH: Tổng quan vẫn mở được từ menu
 * như cũ.
 */
type HomeTarget =
  | { to: "/schedule" | "/customer-chats" | "/dashboard" | "/performance/review" | "/qc-desk/hanh-trinh" }
  | { to: "/performance/review"; search: { tab: "site-check" } };

const QC_HOME_TAB: Partial<Record<ReturnType<typeof qcKindOf>, "site-check">> = {
  facility: "site-check",
};

export function homePathFor(staff: Staff | null | undefined): HomeTarget {
  if (isReceptionDesk(staff)) return { to: "/schedule" };
  if (isCskhDesk(staff)) return { to: "/customer-chats" };
  if ((staff?.role ?? "").toLowerCase().trim() === ROLE.QC) {
    const kind = qcKindOf(staff?.department);
    if (kind === "cskh") return { to: "/qc-desk/hanh-trinh" };
    if (kind !== "none") {
      const tab = QC_HOME_TAB[kind];
      return tab ? { to: "/performance/review", search: { tab } } : { to: "/performance/review" };
    }
  }
  return { to: "/dashboard" };
}

/**
 * Tải lại cả trang vào `/home`: lúc vừa đăng nhập chưa biết người đó là ai
 * (hồ sơ nhân sự nạp trong khung `/_app`), nên `/home` mới là chỗ quyết định
 * đi Lịch chụp, Chat khách hay Tổng quan.
 */
export function goHomeAfterLogin() {
  window.location.assign("/home");
}
